import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import useParsedHtml from '@v4/hooks/useParsedHtml'
import useStyles from './VideoBlock.styled'

const VideoBlock = ({ value, className }) => {
	const classes = useStyles()
	const html = useParsedHtml(value)

	return (
		value && (
			<div className={clsx(className, classes.root, 'video-block')}>
				<div className={clsx(classes.container, 'video-block-container')}>
					<div className={clsx(classes.content, 'video-block-content')}>{html}</div>
				</div>
			</div>
		)
	)
}

VideoBlock.propTypes = {
	className: PropTypes.string,
	value: PropTypes.node,
	classes: PropTypes.shape({
		root: PropTypes.string,
		container: PropTypes.string,
		content: PropTypes.string,
	}),
}

export default memo(VideoBlock)
